import { useState } from 'react'
import copyToClipboard from 'helpers/copyToClipboard'
import { toast } from '@wellesley/system-toast'

import useTimeout from '../useTimeout'

type UseCopyToClipboardProps = {
  textToCopy: string
  toastMsg?: string
}

type UseCopyToClipboardReturn = [() => void, boolean]

const useCopyToClipboard = ({
  textToCopy,
  toastMsg,
}: UseCopyToClipboardProps): UseCopyToClipboardReturn => {
  const [isCopied, setIsCopied] = useState(false)

  useTimeout(
    () => {
      setIsCopied(false)
    },
    isCopied ? 1500 : null,
  )

  const copy = () => {
    setIsCopied(true)
    copyToClipboard(textToCopy)
    toast.success(toastMsg || 'Copied to clipboard')
  }

  return [copy, isCopied]
}

export default useCopyToClipboard
